import React from 'react';
import { useWizardOptionalSectionsStyles } from './WizardOptionalSections.styles';
export function WizardOptionalSections(props) {
    const classes = useWizardOptionalSectionsStyles();
    return (React.createElement("div", { className: props.className, id: props.id },
        React.createElement("div", { className: classes.headline }, "OPTIONAL"),
        props.children));
}
//# sourceMappingURL=WizardOptionalSections.js.map